"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function mapToFooterProps({ data, mappers }) {
    let logo = null;
    const img = data.logo?.[0];
    if (img && typeof img === 'object') {
        logo = mappers.mapBlock({
            block: img,
            mappers,
            inHero: true,
        });
    }
    const disclaimers = [];
    data?.disclaimers?.forEach(({ discReference }) => {
        if (!discReference ||
            typeof discReference !== 'object' ||
            !discReference.brandyRaw)
            return;
        disclaimers.push({
            id: discReference.id,
            text: discReference.brandyRaw,
        });
    });
    return {
        logo,
        logoLink: data.logoLink,
        logoTextColor: data.logoTextColor,
        logoBackgroundColor: data.logoBackgroundColor,
        logoTopBorder: data.logoTopBorder,
        logoBottomBorder: data.logoBottomBorder,
        navigationTextColor: data.navTextColor,
        navigationBackgroundColor: data.navBackgroundColor,
        disclaimers,
        disclaimerTextColor: data.discTextColor,
        disclaimerBackgroundColor: data.discBgColor,
        navData: data.linkGroup?.map((group) => ({
            text: group.title,
            href: group.href,
            subnav: group.subnav,
        })),
    };
}
exports.default = mapToFooterProps;
